export default "__VITE_ASSET__9b430a89__"